/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUltimateBeneficialOwnerInput
 */
export interface UpdateUltimateBeneficialOwnerInput {
    /**
     * Client First Name
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    firstName: string;
    /**
     * Client Last Name
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    lastName: string;
    /**
     * Client Nationality (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    nationality?: string;
    /**
     * Client Birthdate
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    dateOfBirth: string;
    /**
     * Client City of Birth
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    cityOfBirth: string;
    /**
     * Client Country of Birth (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    countryOfBirth: string;
    /**
     * Country of Residence (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    countryOfResidence?: string;
    /**
     * Indicate if the UBO is active or not
     * @type {boolean}
     * @memberof UpdateUltimateBeneficialOwnerInput
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateUltimateBeneficialOwnerInput interface.
 */
export function instanceOfUpdateUltimateBeneficialOwnerInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "dateOfBirth" in value;
    isInstance = isInstance && "cityOfBirth" in value;
    isInstance = isInstance && "countryOfBirth" in value;

    return isInstance;
}

export function UpdateUltimateBeneficialOwnerInputFromJSON(json: any): UpdateUltimateBeneficialOwnerInput {
    return UpdateUltimateBeneficialOwnerInputFromJSONTyped(json, false);
}

export function UpdateUltimateBeneficialOwnerInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUltimateBeneficialOwnerInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'nationality': !exists(json, 'nationality') ? undefined : json['nationality'],
        'dateOfBirth': json['dateOfBirth'],
        'cityOfBirth': json['cityOfBirth'],
        'countryOfBirth': json['countryOfBirth'],
        'countryOfResidence': !exists(json, 'countryOfResidence') ? undefined : json['countryOfResidence'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function UpdateUltimateBeneficialOwnerInputToJSON(value?: UpdateUltimateBeneficialOwnerInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'nationality': value.nationality,
        'dateOfBirth': value.dateOfBirth,
        'cityOfBirth': value.cityOfBirth,
        'countryOfBirth': value.countryOfBirth,
        'countryOfResidence': value.countryOfResidence,
        'isActive': value.isActive,
    };
}

